type ButtonCellStyles = {
  mobile?: { asset_alignment?: string };
  tablet?: { asset_alignment?: string };
  desktop?: { asset_alignment?: string };
  'large-desktop'?: { asset_alignment?: string };
};

const getAssetFlexDirection = (alignment: string | undefined): string => {
  return alignment === 'right' ? 'flex-row-reverse' : 'flex-row';
};

export function getButtonCellFlexDirection(styles: ButtonCellStyles): string {
  return [
    `mobile:max-tablet:${getAssetFlexDirection(
      styles.mobile?.asset_alignment
    )}`,
    `tablet:max-desktop:${getAssetFlexDirection(
      styles.tablet?.asset_alignment
    )}`,
    `desktop:max-large-desktop:${getAssetFlexDirection(
      styles.desktop?.asset_alignment
    )}`,
    `large-desktop:${getAssetFlexDirection(
      styles['large-desktop']?.asset_alignment
    )}`,
  ].join(' ');
}
